import { allIntegrations } from 'ducks/integrations/operations/integrations.data'

export const getIntegrationConfig = providerId => {
  return allIntegrations.find(i => i.id === providerId)
}
